var _g, _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGeoBlocking({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 15C30 17.9667 29.1203 20.8668 27.472 23.3335C25.8238 25.8003 23.4811 27.7229 20.7402 28.8582C17.9994 29.9935 14.9834 30.2905 12.0737 29.7117C9.16394 29.1329 6.49118 27.7044 4.39339 25.6066C2.2956 23.5088 0.86701 20.836 0.288232 17.9263C-0.290546 15.0166 0.00648648 12.0006 1.1418 9.25976C2.27712 6.51887 4.1997 4.1762 6.66644 2.52798C9.13317 0.879756 12.0333 2.28882e-05 15 2.28882e-05C18.9782 2.28882e-05 22.7936 1.58032 25.6066 4.39336C28.4197 7.20641 30 11.0218 30 15Z",
    fill: "url(#paint0_linear)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7902 10.0649L18.3602 17.7449C18.3142 17.9014 18.2296 18.0437 18.1143 18.159C17.999 18.2743 17.8566 18.3589 17.7002 18.4049L10.0502 20.805C9.87915 20.8564 9.69469 20.8379 9.53724 20.7535C9.37979 20.6692 9.2622 20.5258 9.21021 20.3549C9.16561 20.2287 9.16561 20.0912 9.21021 19.965L11.6102 12.27C11.6609 12.116 11.7469 11.9759 11.8616 11.8613C11.9762 11.7467 12.1162 11.6606 12.2702 11.61L19.9502 9.20993C20.0684 9.17357 20.1944 9.17042 20.3143 9.20078C20.4342 9.23113 20.5435 9.29382 20.6302 9.38205C20.7168 9.47029 20.7776 9.58068 20.8058 9.70111C20.8341 9.82154 20.8287 9.94738 20.7902 10.0649Z",
    fill: "url(#paint1_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M24.3802 6.36994L15.0004 16.0194L6.48045 24.7489C6.40392 24.8281 6.31228 24.891 6.21092 24.9339C6.10956 24.9769 6.00058 24.999 5.89049 24.9989C5.77889 24.9992 5.66831 24.9772 5.5653 24.9343C5.46228 24.8913 5.36885 24.8284 5.29046 24.7489C5.15986 24.6085 5.07699 24.4303 5.05365 24.24C5.0303 24.0496 5.06766 23.8568 5.16046 23.689L5.23046 23.599L23.1802 5.17C23.257 5.08763 23.3498 5.02193 23.4531 4.97702C23.5563 4.9321 23.6677 4.90891 23.7803 4.90891C23.8928 4.90891 24.0042 4.9321 24.1074 4.97702C24.2106 5.02193 24.3035 5.08763 24.3802 5.17C24.5385 5.3356 24.6269 5.55586 24.6269 5.78495C24.6269 6.01405 24.5385 6.23431 24.3802 6.39991",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i",
    x: 0,
    y: 0.0000228882,
    width: 30,
    height: 31.9999,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.279167 0 0 0 0 0.655653 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -2.25706,
    y1: -30.5999,
    x2: 36.6163,
    y2: -28.596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#93CFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2894FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 15.0002,
    y1: 20.8335,
    x2: 15.0002,
    y2: 9.18012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ADDCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5028,
    stopColor: "#EAF6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF6FF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeoBlocking);
export default __webpack_public_path__ + "static/media/geo-blocking.df860a538c689cf86cfcc9fa8bb02efe.svg";
export { ForwardRef as ReactComponent };